import { getUploadFile } from "JS/API";

//  export 함수 추가 : 다른 파일에서 가져다 쓸 수 있게 내보내는 키워드
export const generateImage = (textArray, setFileName, setImagePath) => { // 텍스트 배열을 매개변수로 받음
  const imgText = textArray?.join("\n") ?? "상표명\n미리보기"; // 텍스트 배열이 없을 경우 기본 텍스트 설정    
  const padding = 20; // 패딩 설정
  const canvasWidth = 300; // 캔버스 너비 설정
  const canvasHeight = 300; // 캔버스 높이 설정

  const canvas = document.createElement("canvas"); // 캔버스 생성
  const context = canvas.getContext("2d"); // 캔버스 컨텍스트 생성
  canvas.width = canvasWidth; // 캔버스 너비 설정
  canvas.height = canvasHeight; // 캔버스 높이 설정

  let fontSize = 100; // 폰트 크기 설정
  const lines = imgText.split("\n"); // 텍스트 배열을 줄바꿈 문자로 분리

  // 폰트 크기 줄이기: 너비와 높이 모두 초과하지 않을 때까지
  while (fontSize > 5) {
    context.font = `${fontSize}px sans-serif`;
    const maxLineWidth = Math.max(
      ...lines.map((line) => context.measureText(line).width)
    );
    const lineHeight = fontSize * 1.2;
    const totalHeight = lines.length * lineHeight;

    if (
      maxLineWidth <= canvasWidth - padding * 2 &&
      totalHeight <= canvasHeight - padding * 2
    ) {
      break;
    }
    fontSize -= 2;
  }

  const lineHeight = fontSize * 1.2; // 줄 높이 설정
  const totalTextHeight = lines.length * lineHeight; // 총 텍스트 높이 계산
  let startY = (canvas.height - totalTextHeight) / 2 + lineHeight / 2; // 시작 Y 좌표 계산

  // 배경
  context.fillStyle = "#ffffff"; // 배경 색상 설정
  context.fillRect(0, 0, canvas.width, canvas.height); // 배경 채우기

  // 텍스트
  context.fillStyle = "#000000"; // 텍스트 색상 설정
  context.textAlign = "center"; // 텍스트 정렬 설정
  context.textBaseline = "middle"; // 텍스트 기준선 설정
  context.font = `${fontSize}px sans-serif`; // 폰트 설정

  lines.forEach((line, i) => {
    const y = startY + i * lineHeight; // 각 줄의 Y 좌표 계산
    context.fillText(line, canvas.width / 2, y); // 텍스트 채우기
  });

  // 캔버스를 이미지로 변환하여 반환
  // return canvas.toDataURL("image/jpeg", 1);

  const dataUrl = context.canvas.toDataURL("image/jpeg", 1);

  uploadCanvasImage(dataUrl, setFileName, setImagePath, "logo_agent")
  return dataUrl;
  //기존 코드
  // const dataUrl = canvas.toDataURL("image/jpeg", 1); // 이미지 데이터 URL 생성
  // setGeneratedImage(dataUrl); // 생성된 이미지를 상태에 저장
  // setImgUrl(dataUrl); // 이미지 URL을 상태에 저장
};


export const generateCompoundImage = (
  img,
  compoundMarkNameArr,
  setCompoundImageFilename,
  setCompoundImagePath
) => {
  return new Promise((resolve, reject) => {
    if (!img) {
      reject("이미지가 없습니다");
      return;
    }

    const baseWidth = 300;
    const baseHeight = 300;
    const scale = 2;

    // 1. 고해상도 캔버스 (예: 600x600)
    const highResCanvas = document.createElement("canvas");
    const highResCtx = highResCanvas.getContext("2d");
    highResCanvas.width = baseWidth * scale;
    highResCanvas.height = baseHeight * scale;
    highResCtx.scale(scale, scale);

    const padding = 10;
    const textImageGap = 25;

    highResCtx.fillStyle = "#ffffff";
    highResCtx.fillRect(0, 0, baseWidth, baseHeight);

    const image = new Image();
    image.crossOrigin = "anonymous";

    image.onerror = (error) => {
      console.error("이미지 로드 오류:", error);
      reject("이미지 로드에 실패했습니다");
    };

    image.src = img;

    image.onload = () => {
      const textSpace = 45;
      const maxImgHeight = baseHeight - padding * 2 - textSpace - textImageGap;

      let imgWidth, imgHeight;
      if (image.width / image.height > baseWidth / maxImgHeight) {
        imgWidth = baseWidth - padding * 2;
        imgHeight = (image.height / image.width) * imgWidth;
      } else {
        imgHeight = maxImgHeight;
        imgWidth = (image.width / image.height) * imgHeight;
      }

      const imgX = (baseWidth - imgWidth) / 2;
      const availableHeight = baseHeight - textSpace;
      const imgY = (availableHeight - imgHeight) / 2;

      highResCtx.drawImage(image, imgX, imgY, imgWidth, imgHeight);

      // 텍스트도 고해상도로 처리
      highResCtx.font = "16px Arial"; // 8px × 2
      drawText(
        highResCtx,
        compoundMarkNameArr,
        baseWidth,
        imgY + imgHeight + textImageGap,
        setCompoundImageFilename,
        setCompoundImagePath
      );

      // 2. 최종 300x300으로 리사이즈해서 저장
      const finalCanvas = document.createElement("canvas");
      finalCanvas.width = baseWidth;
      finalCanvas.height = baseHeight;
      const finalCtx = finalCanvas.getContext("2d");
      finalCtx.imageSmoothingEnabled = true;
      finalCtx.imageSmoothingQuality = "high";
      finalCtx.drawImage(highResCanvas, 0, 0, baseWidth, baseHeight);

      const dataUrl = finalCanvas.toDataURL("image/jpeg", 1);
      resolve(dataUrl);
    };
  });
};


/** 🔹 캔버스에 텍스트 추가 */
const drawText = (context, textArray, width, startY, setCompoundImageFilename, setCompoundImagePath) => {
  let fontSize = 17; // 🔹 폰트 크기 기본값을 줄임

  const lines = textArray.filter((text) => text.trim() !== ""); // 빈 문자열 제거
  context.font = `${fontSize}px sans-serif`; // 폰트 설정

  const adjustFontSize = () => {
    let maxTextWidth = 0;

    // 각 라인의 너비 계산
    for (const line of lines) {
      const metrics = context.measureText(line);
      const lineWidth = metrics.width;
      maxTextWidth = Math.max(maxTextWidth, lineWidth);
    }

    const maxAllowedWidth = width - 40; // 좌우 각각 20px 여백

    return { maxTextWidth, maxAllowedWidth };
  };

  let { maxTextWidth, maxAllowedWidth } = adjustFontSize();

  // 너비가 초과되면 폰트 크기 줄이기
  let attempts = 0;
  while (maxTextWidth > maxAllowedWidth && fontSize > 25 && attempts < 20) {
    fontSize -= 2;
    context.font = `${fontSize}px sans-serif`;
    const result = adjustFontSize();
    maxTextWidth = result.maxTextWidth;
    maxAllowedWidth = result.maxAllowedWidth;
    attempts++;
  }

  // 스타일 설정
  context.fillStyle = "#000000";
  context.textAlign = "center";
  context.textBaseline = "middle";

  // 줄 간격을 폰트 크기에 비례하게 설정 (더 작게)
  const lineHeight = fontSize * 1.0;
  let y = startY;

  // 텍스트 그리기
  lines.forEach((line) => {
    context.fillText(line, width / 2, y);
    y += lineHeight;
  });

  const dataUrl = context.canvas.toDataURL("image/jpeg", 1);
  uploadCanvasImage(dataUrl, setCompoundImageFilename, setCompoundImagePath);
};




export const uploadCanvasImage = async (
  dataUrl,
  setFilename,
  setPath,
  fileType = "logo_compound" // 기본값은 복합상표
) => {
  try {
    const blob = await (await fetch(dataUrl)).blob();
    const file = new File([blob], `${fileType}.jpg`, {
      type: "image/jpeg",
    });

    const formData = new FormData();
    formData.append("files", file, file.name);
    formData.append("file_type", fileType);

    const response = await getUploadFile(formData);

    if (response?.data?.length > 0) {
      const { filename, path } = response.data[0];
      setFilename?.(filename);
      setPath?.(path);
    } else {
      console.error("응답 데이터가 없습니다.");
    }

    return response;
  } catch (err) {
    console.error("업로드 중 오류 발생:", err);
    throw err;
  }
};





// 이미지 다운로드 함수
export const downloadImage = (dataUrl, fileName = "image.jpg") => {
  if (!dataUrl) return;

  const link = document.createElement("a");
  link.download = fileName;
  link.href = dataUrl;
  link.click();
};




export const generateFigureImage = (img, setFileName, setImagePath) => {
  return new Promise((resolve, reject) => {
    if (!img) {
      reject("이미지가 없습니다.");
      return;
    }

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    const canvasWidth = 300;
    const canvasHeight = 300;
    const padding = 5;

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, canvas.width, canvas.height);

    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = img;

    image.onload = async () => {
      let imgWidth, imgHeight;
      const imageRatio = image.width / image.height;

      if (imageRatio > 1) {
        imgWidth = canvasWidth - padding * 2;
        imgHeight = imgWidth / imageRatio;
      } else {
        imgHeight = canvasHeight - padding * 2;
        imgWidth = imgHeight * imageRatio;
      }

      const imgX = (canvasWidth - imgWidth) / 2;
      const imgY = (canvasHeight - imgHeight) / 2;

      context.drawImage(image, imgX, imgY, imgWidth, imgHeight);

      const dataUrl = canvas.toDataURL("image/jpeg", 1.0);
      await uploadCanvasImage(dataUrl, setFileName, setImagePath, "logo_figure");

      resolve(dataUrl);
    };

    image.onerror = (err) => {
      reject(err);
    };
  });
};